import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import { selectFundraiserByIdOrSlug } from '@client/redux/fundraiser/fundraiserSelectors';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import QRButton from '../../containers/qrButton/QRButton';
import styles from './assetsPage.scss';
import { loadAssetsPageData, selectAssetsPageData } from './duckAssetsPage';

class AssetsPage extends PureComponent {
  componentDidMount() {
    const { dispatch, match } = this.props;
    const { fundraiserSlug } = match.params;

    dispatch(loadAssetsPageData(fundraiserSlug));
  }

  render() {
    const { fundraiser, pageData } = this.props;
    const assets = getIn(pageData, 'assets');

    return (
      <div className={`${styleHelper.contentContainer} ${styles.wrapper}`}>
        <h1>Ladda ner material</h1>
        <p className={styles.ingress}>
          Här hittar du material som du kan använda för att sprida din insamling
          och visa ditt stöd för hjärt- och lungforskning. Du kan enkelt ladda
          ned de filer du vill använda.
        </p>

        <p className={styles.swishText}>
          Vill du ha din egen QR-kod så att dina vänner enkelt kan swisha till
          din insamling? Tryck på knappen nedan för att generera och ladda ned
          QR-koden i PDF-format.
        </p>
        <QRButton guidCode={getIn(fundraiser, 'neiGuidCode')} />

        <div className={styles.assetsContainer}>
          <h2>Material till din insamling</h2>
          <ul>
            {assets &&
              assets.map((asset) => {
                const sys = getIn(asset, 'sys');
                const fields = getIn(asset, 'fields');
                const title = getIn(fields, 'title');
                const url = getIn(fields, 'file', 'url');

                return (
                  <li key={getIn(sys, 'id')}>
                    <a
                      href={url}
                      className={styleHelper.hlfLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {title}
                    </a>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    );
  }
}

AssetsPage.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  fundraiser: ImmutablePropTypes.map,
  pageData: ImmutablePropTypes.map,
};

function mapStateToProps(state, props) {
  const fundraiserSlug =
    props.match.params && props.match.params.fundraiserSlug;

  const fundraiser = selectFundraiserByIdOrSlug(
    state,
    fundraiserSlug.toString()
  );

  return {
    fundraiser: fundraiser,
    pageData: selectAssetsPageData(state),
  };
}
export default connect(mapStateToProps)(AssetsPage);
